"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _GoogleAnalyticsConnector = _interopRequireDefault(require("./connectors/GoogleAnalyticsConnector"));
var _argumentDigester = _interopRequireDefault(require("./utils/argumentDigester"));
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var argOrder = ['eventCategory', 'eventAction', 'eventLabel', 'eventValue'];
var argOrderNoAction = ['eventCategory', 'eventLabel', 'eventValue'];
var digestArgs = (0, _argumentDigester.default)(argOrder).digest;
var digestArgsWithClientId = (0, _argumentDigester.default)(argOrderNoAction).digest;
var send = function send(hitType) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var digested = digestArgs.apply(void 0, args);
  _GoogleAnalyticsConnector.default.send(hitType, digested);
};
var sendEvent = function sendEvent() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }
  send.apply(void 0, [_constants.GA_EVENT].concat(args));
};
var sendEventWithClientId = function sendEventWithClientId() {
  var digested = digestArgsWithClientId.apply(void 0, arguments);
  _GoogleAnalyticsConnector.default.sendWithClientId(_constants.GA_EVENT, digested);
};
var sendPageView = function sendPageView() {
  _GoogleAnalyticsConnector.default.send(_constants.GA_PAGEVIEW);
};
var set = function set(key, value) {
  _GoogleAnalyticsConnector.default.set(key, value);
};
var _default = {
  send: send,
  sendEvent: sendEvent,
  sendEventWithClientId: sendEventWithClientId,
  sendPageView: sendPageView,
  set: set
};
exports.default = _default;
//# sourceMappingURL=GoogleAnalyticsTracking.js.map